<script setup>
import { onMounted, ref } from 'vue'
import VueMarkdown from 'vue-markdown-render';

//properties set by parent
const props = defineProps({
/* 	selectedChartType: {
		type: String,
		required: true,
	}, */
	indicator: {
		type: Object,
		required: true
	}
}) 

//componenet methods exposed to parent

//events raised by component

//reactive field proxies

const markdownOptions = {
	html: true,
	linkify: true,
};
</script>
<template>
	<div class="highcharts-light">
		<div class="source-indicator" >{{ indicator.indicatorName }}</div>
		<div class="source-content">
			<span class="section-header">Source(s):</span>
			<VueMarkdown class="source-notes" v-if="indicator.source" :source="indicator.source.endsWith('.') ? indicator.source : indicator.source + '.'" :options="markdownOptions" />
			<!--
			<span class="section-header" v-if="indicator.abbreviations && indicator.abbreviations.length > 0">Key:</span>
			<VueMarkdown class="source-notes" v-if="indicator.abbreviations && indicator.abbreviations.length > 0" :source="indicator.abbreviations.join('; ') + '.'" :options="markdownOptions" />
			<span class="section-header">Note(s):</span>
			-->
			<VueMarkdown class="source-notes" v-if="indicator.notes" :source="indicator.notes.endsWith('.') ? indicator.notes : indicator.notes + '.'" :options="markdownOptions" />
		</div>
	</div>
</template>

<style>
.source-indicator {
    display: flex;
    height: 3.4rem;
    padding: 1.5rem;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-bottom: 1px solid var(--borders-DividerActive, #064291);
    background: var(--surface-brand-Blue, #064291);
    color: var(--text-Inverse, #fff);
    font-family: var(--font-family-Title);
    font-size: var(--font-size-H6);
}
.source-content {
	padding: 1.5rem;
}
.section-header {
	font-family: var(--font-family-Title);
	font-weight: 400;
}
.source-source p {
	font-family: var(--font-family-Title);
    font-size: var(--font-size-H6);
	font-weight: 400;
	white-space: pre-line; /* Preserves newlines and wraps text */
}
.source-notes p {
	font-family: var(--font-family-Title);
	white-space: pre-line; /* Preserves newlines and wraps text */
}

</style>